import React, { useState, useEffect } from "react";

import Modal from "../../common/Modal/Modal";
import "./downloadstatusmodal.css";

export default function DownloadStatusModal({onClose, downloadStatus}) {
  const [openModal, setOpenModal] = useState(false);

    // Modal Handling Functions
    useEffect(() => {
        if (downloadStatus) {
            console.log("downloadStatus in modal: ",downloadStatus)
          setOpenModal(true);
        }
      }, [downloadStatus]);

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <>
      <Modal
        isOpen={openModal}
        onClose={handleCloseModal}
        title={downloadStatus.status === "success" ? "Download Complete" : "Download Failed"}
        showCustomContent={true}
        customContent={
            downloadStatus.status === "success" ? (
                // If download is successful
                <>
                  <div className="modal-success-container">
                    <div className="icon-container">
                      <i className="fas fa-check" />
                    </div>
                    <div className="download-success-message">
                    You should be able to find your downloaded file on your local computer.
                    </div>
                  </div>
                  <div className="savemodal-btn-container">
                  <button className="button-close" onClick={handleCloseModal}>
                    Done
                  </button>
                  </div>
                </>
              ) : (
                // Download failed
                <>
                  <div className="download-failed-message">
                  There was a problem completing your download. Please try again or email contact@hecoanalytics.com if the issue persists.
                  </div>
                  <div className="savemodal-btn-container">
                  
                    <button className="button-close" onClick={handleCloseModal}>
                      Done
                    </button>
                  </div>
                </>
              )
        }
      />
    </>
  );
}
